import { render, staticRenderFns } from "./ProfileMenu.vue?vue&type=template&id=3b01ff98&scoped=true&lang=pug"
import script from "./ProfileMenu.vue?vue&type=script&lang=js"
export * from "./ProfileMenu.vue?vue&type=script&lang=js"
import style0 from "./ProfileMenu.vue?vue&type=style&index=0&id=3b01ff98&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b01ff98",
  null
  
)

export default component.exports